// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maximized-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}
.maximized-view .p-datatable {
  /* Grid structure with fixed height and scrollable body */
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  height: auto !important;
  flex-shrink: 0 !important;
}
.maximized-view .p-datatable .p-datatable-header {
  flex-shrink: 0 !important;
}
.maximized-view .p-datatable .p-datatable-wrapper {
  flex-shrink: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  height: auto !important;
  max-height: calc(100vh - 300px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
}
.maximized-view .p-datatable .p-datatable-wrapper .p-datatable-scrollable-wrapper {
  flex: 1 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  height: 100% !important;
}
.maximized-view .p-datatable .p-paginator {
  flex-shrink: 0 !important;
  border-top: 1px solid #dee2e6 !important;
  background: #f9f9f9 !important;
  display: flex !important;
  padding: 8px 15px !important;
  margin-top: 0 !important;
}
.maximized-view .status-icon-column .pi {
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
  font-weight: 500;
  font-size: 20px;
}
.maximized-view.fullheight {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.maximized-view .maximized-view-header {
  flex-shrink: 0;
  border-bottom: 1px solid #dee2e6;
  padding: 2px 10px;
}
.maximized-view .maximized-view-header .view-item-header .title-section h5 {
  font-size: 14px;
}
.maximized-view .maximized-view-header .view-item-header .title-section .title-input {
  font-size: 14px !important;
  height: 32px;
  padding: 6px 10px;
}
.maximized-view .maximized-view-header .view-item-header .title-section .title-action-btn .pi {
  font-size: 14px;
}
.maximized-view .maximized-view-header .view-item-header .header-actions .header-icon-btn .pi {
  font-size: 16px;
}
.maximized-view .maximized-view-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 1rem;
  min-height: 0;
}
.maximized-view .maximized-view-content .view-item-content {
  width: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: visible;
  padding: 0;
  border-radius: 0px;
  border: none;
  box-shadow: none;
  min-height: 0;
}

:global(.p-datatable .p-datatable-thead > tr > th) {
  background: #f3f6fb;
  font-weight: 700;
}

.title-input {
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 0.25rem 0.5rem;
  font-size: 1.15rem;
  font-weight: 700;
  border-radius: 4px;
  outline: none;
}
.title-input:focus {
  border-color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.3);
}

.help-status {
  padding: 0.25rem 0.6rem;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.875rem;
  display: inline-block;
}
.help-status.help-no {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.help-status.help-in-process {
  background-color: #fff3e0;
  color: #ef6c00;
}
.help-status.help-done {
  background-color: #e3f2fd;
  color: #1976d2;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Tabs/DashboardTab/MaximizedView/MaximizedView.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,oCAAA;EACA,+CAAA;AACJ;AACI;EACI,yDAAA;EACA,wBAAA;EACA,iCAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AACR;AACQ;EACI,yBAAA;AACZ;AAEQ;EACI,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,wBAAA;EACA,uBAAA;EACA,0CAAA;EACA,2BAAA;EACA,2BAAA;AAAZ;AAEY;EACI,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;AAAhB;AAIQ;EACI,yBAAA;EACA,wCAAA;EACA,8BAAA;EACA,wBAAA;EACA,4BAAA;EACA,wBAAA;AAFZ;AAOQ;EACI,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AALZ;AASI;EACI,iBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAPR;AAUI;EACI,cAAA;EACA,gCAAA;EACA,iBAAA;AARR;AAYgB;EACI,eAAA;AAVpB;AAagB;EACI,0BAAA;EACA,YAAA;EACA,iBAAA;AAXpB;AAeoB;EACI,eAAA;AAbxB;AAoBoB;EACI,eAAA;AAlBxB;AAyBI;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AAvBR;AAyBQ;EACI,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAvBZ;;AA6BA;EACI,mBAAA;EACA,gBAAA;AA1BJ;;AA6BA;EACI,0CAAA;EACA,oCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AA1BJ;AA4BI;EACI,sCAAA;EACA,oCAAA;AA1BR;;AA+BA;EACI,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AA5BJ;AA8BI;EACI,yBAAA;EACA,cAAA;AA5BR;AA+BI;EACI,yBAAA;EACA,cAAA;AA7BR;AAgCI;EACI,yBAAA;EACA,cAAA;AA9BR","sourcesContent":[".maximized-view {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n\n    .p-datatable {\n        /* Grid structure with fixed height and scrollable body */\n        display: flex !important;\n        flex-direction: column !important;\n        width: 100% !important;\n        height: auto !important;\n        flex-shrink: 0 !important;\n\n        .p-datatable-header {\n            flex-shrink: 0 !important;\n        }\n\n        .p-datatable-wrapper {\n            flex-shrink: 0 !important;\n            display: flex !important;\n            flex-direction: column !important;\n            min-height: 0 !important;\n            height: auto !important;\n            max-height: calc(100vh - 300px) !important;\n            overflow-y: auto !important;\n            overflow-x: auto !important;\n\n            .p-datatable-scrollable-wrapper {\n                flex: 1 !important;\n                overflow-y: auto !important;\n                overflow-x: hidden !important;\n                height: 100% !important;\n            }\n        }\n\n        .p-paginator {\n            flex-shrink: 0 !important;\n            border-top: 1px solid #dee2e6 !important;\n            background: #f9f9f9 !important;\n            display: flex !important;\n            padding: 8px 15px !important;\n            margin-top: 0 !important;\n        }\n    }\n\n    .status-icon-column {\n        .pi {\n            position: relative !important;\n            top: 0 !important;\n            right: 0 !important;\n            font-weight: 500;\n            font-size: 20px;\n        }\n    }\n\n    &.fullheight {\n        min-height: 100vh;\n        height: 100vh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .maximized-view-header {\n        flex-shrink: 0;\n        border-bottom: 1px solid #dee2e6;\n        padding: 2px 10px;\n\n        .view-item-header {\n            .title-section {\n                h5 {\n                    font-size: 14px;\n                }\n\n                .title-input {\n                    font-size: 14px !important;\n                    height: 32px;\n                    padding: 6px 10px;\n                }\n\n                .title-action-btn {\n                    .pi {\n                        font-size: 14px;\n                    }\n                }\n            }\n\n            .header-actions {\n                .header-icon-btn {\n                    .pi {\n                        font-size: 16px;\n                    }\n                }\n            }\n        }\n    }\n\n    .maximized-view-content {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        overflow: auto;\n        padding: 1rem;\n        min-height: 0;\n\n        .view-item-content {\n            width: 100%;\n            flex: 1;\n            display: flex;\n            flex-direction: column;\n            overflow: visible;\n            padding: 0;\n            border-radius: 0px;\n            border: none;\n            box-shadow: none;\n            min-height: 0;\n        }\n    }\n}\n\n// Projects Table Fullscreen Styles\n:global(.p-datatable .p-datatable-thead > tr > th) {\n    background: #f3f6fb;\n    font-weight: 700;\n}\n\n.title-input {\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    background: rgba(255, 255, 255, 0.2);\n    color: #fff;\n    padding: 0.25rem 0.5rem;\n    font-size: 1.15rem;\n    font-weight: 700;\n    border-radius: 4px;\n    outline: none;\n\n    &:focus {\n        border-color: rgba(255, 255, 255, 0.8);\n        background: rgba(255, 255, 255, 0.3);\n    }\n}\n\n// Help Status Styling for Tasks\n.help-status {\n    padding: 0.25rem 0.6rem;\n    border-radius: 4px;\n    font-weight: 500;\n    font-size: 0.875rem;\n    display: inline-block;\n\n    &.help-no {\n        background-color: #e8f5e9;\n        color: #2e7d32;\n    }\n\n    &.help-in-process {\n        background-color: #fff3e0;\n        color: #ef6c00;\n    }\n\n    &.help-done {\n        background-color: #e3f2fd;\n        color: #1976d2;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
